import { datadogRum } from '@datadog/browser-rum';
import { conf } from './conf.js';
import { reusable } from './convincely.js';
export class MonitoringService {
    enabled = false;
    enable() {
        const { applicationId, clientToken, sessionSampleRate = 100, sessionReplaySampleRate = 0, service, env } = conf.monitoring;
        try {
            datadogRum.init({
                applicationId,
                clientToken,
                site: 'datadoghq.com',
                service: service || conf.$appName,
                env: env || conf.env,
                sessionSampleRate,
                sessionReplaySampleRate,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
                defaultPrivacyLevel: 'mask-user-input',
            });
            this.enabled = true;
        }
        catch (dataDogError) {
            // eslint-disable-next-line
            console.error(dataDogError);
        }
    }
    setUserId(userId) {
        datadogRum.setUser({
            id: userId,
        });
    }
    trackError(error, context) {
        if (!this.enabled) {
            return;
        }
        if (conf.isDev) {
            // eslint-disable-next-line no-console
            console.error(error, context);
        }
        try {
            datadogRum.addError(this.sanitiseError(error), context);
        }
        catch (dataDogError) {
            // eslint-disable-next-line no-console
            console.warn(dataDogError);
        }
    }
    addAction(name, context) {
        if (!this.enabled) {
            return;
        }
        if (conf.isDev) {
            // eslint-disable-next-line no-console
            console.log(name, context);
        }
        try {
            datadogRum.addAction(name, context);
        }
        catch (dataDogError) {
            // eslint-disable-next-line no-console
            console.warn(dataDogError);
        }
    }
    sanitiseError(error) {
        if (error instanceof Error) {
            return error;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const res = error;
            return {
                status: res.status,
                statusText: res.statusText,
                url: res.url,
            };
        }
    }
}
export const monitoringService = reusable('monitoringService', new MonitoringService(), conf.$appName);
//# sourceMappingURL=monitoring.js.map